import React, { useEffect } from "react";
import { TOptions, TOptionValue } from "../optionsUtils";
import Checkbox from "../types/checkbox/Checkbox";
import Radio from "../types/radio/Radio";
import Toggle from "../types/toggle/Toggle";

import "./SmallOptionContainer.scss";

interface IProps {
    id: string;
    type: TOptions;
    title?: React.ReactNode | undefined;
    value?: TOptionValue;
    onClick?: (e) => void;
    disabled?: boolean;
}

export default function SmallOptionContainer(props: IProps) {
    const [value, setValue] = React.useState<TOptionValue>(props.value || "unselected");

    const onClick = (e) => {
        if (props.onClick) {
            props.onClick(e);
        }

        if (props.disabled) {
            return;
        }

        if (value === "selected") {
            setValue("unselected");
        } else if (value === "unselected") {
            setValue("selected");
        } else {
            setValue("indeterminate");
        }
    };

    useEffect(() => {
        if (props.value) {
            setValue(props.value);
        }
    }, [props.value]);

    return (
        <div
            id={props.id + "-small-option-container"}
            onClick={onClick}
            className={`userful-small-option-container noselect ${
                value === "selected"
                    ? "userful-small-opiton-container-selected"
                    : value === "indeterminate"
                      ? "userful-small-opiton-container-indeterminate"
                      : ""
            } 
            ${props.disabled ? "userful-small-opiton-container-disabled" : ""}`}
        >
            <div className="userful-small-option-input">
                {props.type === "checkbox" && <Checkbox value={value} onClick={onClick} disabled={props.disabled} />}
                {props.type === "radio" && <Radio value={value} onClick={onClick} disabled={props.disabled} />}
                {props.type === "toggle" && <Toggle value={value} onClick={onClick} disabled={props.disabled} />}
            </div>
            <h1 className="noselect">{props.title}</h1>
        </div>
    );
}
